import { z } from 'zod';

export const MeResponse = z.object({
  userId: z.string().uuid(),
  utEid: z.string().nullable(),
  givenName: z.string().nullable(),
  familyName: z.string().nullable(),
  displayName: z.string(),
  // Avatar initials, computed by the API from the AD name parts
  // (api/src/repositories/person.ts). The web renders this verbatim and
  // must never derive initials itself.
  initials: z.string(),
  role: z.enum(['contributor', 'approver', 'administrator']),
  teams: z.array(
    z.object({
      teamId: z.string().uuid(),
      name: z.string(),
      role: z.enum(['contributor', 'approver']),
    }),
  ),
  // True when the user leads at least one project — lets the SPA show the
  // Projects nav to a non-approver lead (slice S-A). Optional so older mocks and
  // clients that omit it default to false.
  leadsAnyProject: z.boolean().optional(),
});
export type MeResponse = z.infer<typeof MeResponse>;
